import {
  FullscreenOverlayBackdrop,
  FullscreenOverlayBody,
  FullscreenOverlayContent,
  FullscreenOverlayHeader,
  FullscreenOverlayPortal,
  FullscreenOverlayRoot,
} from '../../../ui/FullscreenOverlay';
import * as styles from './tourLightbox.styles';

type VideoLightboxProps = {
  videoUrl: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function toEmbedUrl(url: string): string {
  // https://youtu.be/VIDEO_ID → https://www.youtube.com/embed/VIDEO_ID
  const shortMatch = url.match(/youtu\.be\/([^?&#]+)/);
  if (shortMatch) {
    return `https://www.youtube.com/embed/${shortMatch[1]}`;
  }

  // https://www.youtube.com/watch?v=VIDEO_ID → https://www.youtube.com/embed/VIDEO_ID
  const longMatch = url.match(/youtube\.com\/watch\?v=([^&#]+)/);
  if (longMatch) {
    return `https://www.youtube.com/embed/${longMatch[1]}`;
  }

  // Already an embed URL or unrecognized format — return as-is
  return url;
}

function toAutoplayUrl(url: string): string {
  const embedUrl = toEmbedUrl(url);
  const separator = embedUrl.includes('?') ? '&' : '?';
  return `${embedUrl}${separator}autoplay=1`;
}

export const VideoLightbox = ({ videoUrl, open, onOpenChange }: VideoLightboxProps) => (
  <FullscreenOverlayRoot open={open} onOpenChange={onOpenChange}>
    <FullscreenOverlayPortal>
      <FullscreenOverlayBackdrop>
        <FullscreenOverlayContent
          variant="media"
          className={styles.tourLightboxContent}
          ariaLabelledBy="video-lightbox-title"
        >
          <FullscreenOverlayHeader layout="floating" variant="media" />

          <FullscreenOverlayBody variant="media" padding="edge-to-edge">
            <div className={styles.tourLightboxContainer}>
              <iframe
                src={toAutoplayUrl(videoUrl)}
                title="Listing video"
                id="video-lightbox-title"
                aria-label="Listing video player"
                className={styles.tourLightboxIframe}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </FullscreenOverlayBody>
        </FullscreenOverlayContent>
      </FullscreenOverlayBackdrop>
    </FullscreenOverlayPortal>
  </FullscreenOverlayRoot>
);
